import { render, staticRenderFns } from "./BounceRate.vue?vue&type=template&id=3b70b922"
import script from "./BounceRate.vue?vue&type=script&lang=js"
export * from "./BounceRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports